export const CLASS_ID_PARAM = 'classId';
export const NOTIFICATION_SHOW_DELAY = 2000;
export const JOIN_CODE_NOTIFICATION_MESSAGE = "You've been enrolled!";

export const NOTIFICATION_STALE_PERIOD_IN_DAYS = 7;
